import { createTheme } from '@mui/material/styles';

import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const theme = createTheme({
  palette,
  typography,
  components: overrides, // In MUI v5, 'overrides' is now 'components'
  zIndex: {
    appBar: 1200,
    drawer: 1100
  },
  spacing: (factor) => 8 * factor, // Spacing function that returns calculated values
});

export default theme;
